import React, { Component, useState } from "react";
import { ProductType } from "../../../../utils/Order/Order";
import { Container, Col, Row, Tooltip } from "reactstrap";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import style from "./Precheck.module.scss";

const Details = ({ form, precheck, ...props }) => {
  let result = props.result;

  for (var key in result) {
    if (result.hasOwnProperty(key)) {
      if (typeof result[key] !== 'boolean' && !isNaN(result[key])) {
        result[key] = +result[key];
      }
    }
  }

  const [tooltipOpen, setTooltipOpen] = useState({});
  const toggleTooltip = (index) => {
    setTooltipOpen({
      ...tooltipOpen,
      [index]: !tooltipOpen[index],
    });
  };

  const rows = details(result, form, props.additionalProps);

  return (
    <div className={style.details}>
      <Container style={{ padding: 0, margin: "0 -15px", width: "calc(100% + 30px)" }}>
        <Row noGutters>
          <Col lg={{ size: 5 }}>
            <div className={style.totals}>
              <table>
                <tbody>
                  {rows.map((row, index) => {
                    const tooltipId = `tooltip-${index}`;
                    return (
                      <div key={`pcheck-${index}`}>
                        <tr>
                          <td>{row.label}</td>
                          <td>
                            <Number value={row.value} dataTypeDecimalName="currency" />
                          </td>
                          {row.warning && row.warning != 0 ? (
                            <div>
                              <i
                                id={tooltipId}
                                className="icon-exclamation icons font-xl"
                                style={{
                                  color: "orange",
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  display: "inline-block",
                                }}
                              ></i>
                              <Tooltip
                                isOpen={tooltipOpen[index] || false}
                                target={tooltipId}
                                toggle={() => toggleTooltip(index)}
                              >
                                {row.warning}
                              </Tooltip>
                            </div>
                          ) : null}
                        </tr>
                      </div>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Col>
          <Col lg={7}>
            <div className={style.earnings}>
              <table>
                <tbody>
                  <tr>
                    <td className={style.bold}>Earnings</td>
                    <td className={`${style.bold} text-right`}>Amount</td>
                    <td className={`${style.bold} text-right`}>Tax</td>
                    <td className={`${style.bold} text-right`}>Total</td>
                  </tr>
                  <tr>
                    <td className={style.bold}>UpFront</td>
                    <td className="text-right">
                      <Number value={result.upfront} dataTypeDecimalName="currency" />
                    </td>
                    <td className="text-right">
                      <Number value={result.taxupfront} dataTypeDecimalName="currency" />
                    </td>
                    <td className="text-right">
                      <Number value={result.upfront + result.taxupfront} dataTypeDecimalName="currency" />
                    </td>
                  </tr>

                  {precheck.FXMarkupAllowed && (
                    <tr>
                      <td className={style.bold}>FX UpFront</td>
                      <td className="text-right">
                        <Number value={result.fxupfront} dataTypeDecimalName="currency" />
                      </td>
                      <td className="text-right">
                        <Number value={result.taxfxupfront} dataTypeDecimalName="currency" />
                      </td>
                      <td className="text-right">
                        <Number
                          value={result.fxupfront + result.taxfxupfront}
                          dataTypeDecimalName="currency"
                        />
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td className={style.bold}>Commission</td>
                    <td className="text-right">
                      <Number value={result.commission} dataTypeDecimalName="currency" />
                    </td>
                    <td className="text-right">
                      <Number value={result.tax} dataTypeDecimalName="currency" />
                    </td>
                    <td className="text-right">
                      <Number value={result.commission + result.tax} dataTypeDecimalName="currency" />
                    </td>
                  </tr>

                  <tr>
                    <td className={style.bold}>Total</td>
                    <td className="text-right">
                      <Number value={result.upfront + result.commission} dataTypeDecimalName="currency" />
                    </td>
                    <td className="text-right">
                      <Number value={result.taxupfront + result.tax} dataTypeDecimalName="currency" />
                    </td>
                    <td className="text-right">
                      <Number
                        value={result.upfront + result.taxupfront + result.commission + result.tax}
                        dataTypeDecimalName="currency"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className={style.bold}>%</td>
                    <td className="text-right">
                      <Number value={result.EarningsPercentage} dataTypeDecimalName="percentage" />
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export const Number = ({ value, dataTypeDecimalName, decimalScale }) => {
  return (
    <FormattedNumber value={value} decimalScale={decimalScale} dataTypeDecimalName={dataTypeDecimalName} />
  );
};

const details = (result, form, additionalProps) => {
  const commons = (sufix = "") => [
    { label: `SubTotal${sufix}`, value: result.subtotal, warning: "" },
    {
      label: result.charge > 0 ? `Charge${sufix}` : `Commission${sufix}`,
      value: result.charge > 0 ? result.charge : result.commission,
      warning: result.charge > 0 ? result.Warnings : "",
    },
    { label: `Tax${sufix}`, value: result.tax, warning: "" },
    { label: `Total${sufix}`, value: result.Total, warning: "" },
  ];

  switch (form) {
    case ProductType.BOND:
      return [
        { label: "Principal", value: result.Principal },
        { label: "Accruals", value: result.Accrual },
        ...commons(),
      ];

    case ProductType.EQUITY:
    case ProductType.FUTURE:
    case ProductType.OPTION:
    case ProductType.REPO:
    case ProductType.MMARKET:
      return [{ label: "Principal", value: result.Principal }, ...commons()];

    case ProductType.MFUNDS:
    case ProductType.FOREX:
      const otherProps = {};
      let otherValues = [];

      if (additionalProps) {
        additionalProps.forEach((item, index) => {
          otherProps[item.key] = item.value;
        });
      }

      if (otherProps.hasOwnProperty("FX_Title")) {
        otherValues.push({ label: otherProps["FX_Title"], value: otherProps["FX_Total"] });
      }

      return [{ label: "Principal", value: result.Principal }, ...commons(" "), ...otherValues];
  }
};

export { details as detailsFields };

export default Details;
